/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

import {commonTranslations} from "./common"

export const analysisTranslations = {
    title: "SMRT Analysis",
    link: "New Analysis",
    list: {
        title: commonTranslations.analyses,
        bamRawData: "Raw Data, BAM",
        barcodes: "Barcodes",
        createAnalysis: "Create New Job",
        error: commonTranslations.error,
        import: commonTranslations.import,
        importData: commonTranslations.importSequenceData,
        ok: commonTranslations.ok,
        references: "References",
        subreadSet: "Sequel Data",
        exportAnalysis: "Export Job",
        importAnalysis: "Import Job"
    },
    select: {
        title: "Create New Job - Select Data",
        cancel: commonTranslations.cancel,
        error: commonTranslations.error,
        next: "Next",
        ok: commonTranslations.ok
    },
    details: {
        title: "Job Details - {title}",
        cancel: commonTranslations.cancel,
        analyze: "Analyze",
        additionalDetails: "Additional Details"
    },
    results: {
        title: "Job Results - {jobName}",
        analysis: "Analysis",
        analysisId: "Analysis Id",
        smrtLinkLog: commonTranslations.smrtLinkLog,
        analysisMetric: commonTranslations.analysisMetric,
        analysisOverview: "Analysis Overview",
        analysisParameters: "Analysis Parameters",
        application: commonTranslations.application,
        attributes: commonTranslations.attributes,
        createdAt: commonTranslations.createdAt,
        createdBy: commonTranslations.createdBy,
        importedAt: commonTranslations.importedAt,
        smrtlinkVersion: commonTranslations.smrtlinkVersion,
        data: commonTranslations.data,
        displayAll: commonTranslations.displayAll,
        errorMessage: commonTranslations.errorMessage,
        file: commonTranslations.file,
        fileDownloads: commonTranslations.fileDownloads,
        inputs: commonTranslations.inputs,
        multiStatus: "Status of Individual Analyses",
        noLogAvailable: commonTranslations.noLogAvailable,
        preAnalysis: commonTranslations.preAnalysis,
        parentAnalysis: "From Multi-Job",
        path: commonTranslations.path,
        size: commonTranslations.size,
        smrtView: "SMRT View",
        status: commonTranslations.status,
        thumbnails: commonTranslations.thumbnails,
        type: commonTranslations.type,
        updatedAt: commonTranslations.updatedAt,
        value: commonTranslations.value,
        delete: commonTranslations.allCapsDelete
    },
    settings: {
        title: "Create New Job - Settings",
        advancedAnalysisParameters: "Advanced Analysis Parameters",
        analysisApplication: commonTranslations.analysisApplication,
        analysisType: "Analysis Type",
        cancel: commonTranslations.cancel,
        collectionsInDataset: "Collections in {datasetName}",
        dataset: commonTranslations.dataset,
        error: commonTranslations.error,
        name: "Analysis Name",
        namePrefix: "Analysis Name Prefix *",
        off: "off",
        on: "on",
        ok: commonTranslations.ok,
        select: "Select",
        start: "Start",
        startAndCreateNext: "Start and Create next",
        startAndComplete: "Start and Complete"
    },
    export: {
        exportSelected: "Export Selected Jobs",
        cancel: commonTranslations.cancel,
        title: "Export Jobs"
    },
    analysisSelector: {
        analyses: commonTranslations.analyses
    }
}
